// CRM integration: replace this submit handler with your Klaviyo or HubSpot form integration.
// Field names are name, email and phone. No contact data is stored or transmitted here.
document.querySelectorAll('[data-tyent-lead-form]').forEach(form => {
 if (form.dataset.bound) return;
 form.dataset.bound = 'true';
 form.addEventListener('submit', event => {
  event.preventDefault();
  form.querySelector('.form-status').textContent = 'This form is not connected yet. Please call the Tyent team at 855-893-6887.';
 });
});
